import { PServed } from '@wui/im'
import { v4 as uuid } from 'uuid'

import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'

import { useStoreContacts } from '@/entities/contact'

import { useCurrentUser } from '@/shared/composables/current-user'
import { Contact } from '@/shared/types/api'
import { Room } from '@/shared/types/store'
import { getSystemBotContact } from '@/shared/utils/contacts'

export function createPrivateRoom (roomId: string, contact: {
  imLogin: string
  internalNumber: string
  name: string
  id: PServed
  groupIds: Array<string>
}): Room {
  const { findByPServed, internalNumberContactMap } = useStoreContacts()
  const subscribers = new Map()
  const resolvedContact = getSystemBotContact(roomId) ?? getSystemBotContact(contact.imLogin) ?? contact
  const storeContact = resolvedContact.imLogin ? findByPServed(resolvedContact.imLogin) : internalNumberContactMap[resolvedContact.internalNumber] // Для внешнего контакта imLogin = ""

  if (storeContact) {
    subscribers.set(uuid(), storeContact)
  } else {
    subscribers.set(uuid(), resolvedContact)
  }

  const room: Room = {
    id: roomId,
    pServedUser: roomId,
    isGroup: false,
    name: resolvedContact.name ?? storeContact?.name,
    number: resolvedContact.internalNumber,
    subscribers,
    isEnabled: true,
    isExternal: !storeContact?.imLogin && !resolvedContact.imLogin,
  }
  const storeRooms = useStoreRooms()
  storeRooms.createRoom(room)
  return room
}

export function convertNumbersToSubscribersMap (subscribersNumbers: string[]): Map<string, Contact> {
  const { currentUser } = useCurrentUser()
  const storeContacts = useStoreContacts()
  const subscribers = new Map<string, Contact>()
  if (currentUser.value?.id) {
    subscribers.set(currentUser.value.id, currentUser.value as Contact)
  }
  return subscribersNumbers.reduce((acc, phoneNumber) => {
    const contact = storeContacts.findByInternalNumber(phoneNumber)
    if (contact) {
      acc.set(contact.id, contact)
    }
    return acc
  }, subscribers)
}

export function convertNumbersToSubscribersMapWithCurrentSubscriber (subscribersNumbers: string[]): Map<string, Contact> {
  const subscribers = convertNumbersToSubscribersMap(subscribersNumbers)
  const { currentUser } = useCurrentUser()
  if (currentUser.value?.id) {
    subscribers.set(currentUser.value.id, currentUser.value as Contact)
  }
  return subscribers
}
